import React from 'react';
import { Pagination } from 'swiper';
import { GiJourney } from "react-icons/gi";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Class 10th',
      role: 'Full-Stack Web Developer. JavaScript | Rails | React | Redux. Improving open-source projects, one commit at a time.',
      test: 'I proudly completed my Class 10th from Montfort Inter College, Lucknow, achieving an outstanding score of 91.6%. This achievement reflects my hard work, dedication, and a strong academic foundation.',
    },
    {
      id: 2,
      name: 'Class 12th',
      role: 'Full-stack developer | Technical Support Engineer at Microverse',
      test: "I proudly completed my Class 12th from Montfort Inter College, Lucknow, achieving an outstanding score of 84.2%.This remarkable achievement highlights my consistent effort, determination, and strong academic abilities. It serves as a key milestone in my educational journey, showcasing my dedication to pursuing excellence and setting a solid foundation for future academic and personal successes.",
    },
    {
      id: 3,
      name: 'Undergradute',
      role: 'Full Stack Developer| Ruby on Rails | PostgreSQL | JavaScript | React | Redux | Html&Css | Python.',
      test: ' am currently pursuing my Bachelor of Technology (B.Tech) in Computer Science and Engineering from Jain University, Bangalore. I am in my 4th year of this rigorous program, which has provided me with a deep understanding of various aspects of computer science, from algorithms to software development. Throughout my academic journey, I have consistently maintained a high standard of excellence, as reflected in my impressive overall CGPA of 9.4.',
    },
    {
      id: 4,
      name: 'Iternships at Etechmy',
      role: 'Full-Stack Web Developer. JavaScript | Rails | React | Redux.',
      test: "II worked as a Web Developer Intern at Etechmy for two months, where I specialized in front-end development using HTML, CSS, Bootstrap, and Tailwind, along with backend integration using MySQL. My primary responsibilities included developing and refining the admin dashboard, creating a complete authentication system, and building user-friendly front-end pages. This experience allowed me to deepen my understanding of web development frameworks and best practices, further enhancing my ability to create efficient and effective web solutions.",
    },
    {
      id: 5,
      name: 'Internship at RuralHandmade',
      role: 'Software Developer',
      test: "TI worked as a Web Developer Intern at Rural Handmade for one month, where I focused on developing the front end of the company's website. During this internship, I gained valuable hands-on experience in web development and had the opportunity to learn and implement new techniques. This experience enhanced my skills in creating user-friendly and visually appealing web interfaces, further solidifying my passion for web development and technology.",
    },
    {
      id: 6,
      name: 'Tech Lead Enigma Club',
      role: 'Full Stack Developer | Mindful Mentor | Cheerful Team Player',
      test: "I am currently appointed as the Technical Head of our Computer Science Department's core club, ENIGMA. Additionally, I am serving as the Student Coordinator for our department for this academic year. These roles have given me the opportunity to lead technical initiatives, coordinate events, and represent my peers, allowing me to contribute significantly to our department's growth and community.",
    },
  ];
  return (
    <section id="testmonials">
      <h5>Know more about</h5>
      <h2>My Journey</h2>
      <Swiper 
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial" key={test.id}>
          <div className="client__avatar">
            
              <GiJourney/>
            
          </div>
          <h5 className='client__name'>{test.name}</h5>
          <small className="client__review">{test.test}</small>
        </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default Testimonials